export class Modal {
    constructor() {
        this.openBtn = {};
        this.closeBtn = {};
        this.contentElem = {};
        this.contentContainerElem = {};

        this.openBtnElemId = 'js-btn-register-modal';
        this.closeBtnElemId = 'js-btn-register-close';
        //this.contentElemId = 'js-content-modal-register';
        this.overlayElemId = 'js-overlay';
    }

    init() {
        this.body = document.getElementsByTagName('body')[0];


        // openBtn
        if (document.getElementById(this.openBtnElemId)) {
            let elem = document.getElementById(this.openBtnElemId);
            elem.addEventListener('click', (e) => {
                e.preventDefault();

                this.openModal();
                this.checkOverflow();
            });


        }

        // closeBtn
        if (document.getElementById(this.closeBtnElemId)) {
            let elem = document.getElementById(this.closeBtnElemId);
            elem.addEventListener('click', (e) => {
                e.preventDefault();
                this.closeModal();
            });
        }
    }

    openModal() {
        this.body.classList.add('modal-open');
        console.log('open Modal');
    }

    closeModal() {
        this.body.classList.remove('modal-open');
        console.log('close Modal');
    }

    checkOverflow() {
        //this.body.classList.add('mwedfewdfwe');

        //jsでコンテンツがウインドウサイズを超える場合は.content-modal-register-container に .js-overflowを付与する
        let windowHeight = (window.innerHeight || document.documentElement.clientHeight || 0);
        //console.log(windowHeight);
        this.contentContainerElem = document.querySelector('#' + this.overlayElemId + ' .content-modal-register-container');
        this.contentElem = document.querySelector('#' + this.overlayElemId + ' .content-modal-register');

        console.log(this.contentElem.clientHeight);


        if (this.contentElem.clientHeight > windowHeight) {
            this.contentContainerElem.classList.add('js-overflow');
        } else {
            this.contentContainerElem.classList.remove('js-overflow');
        }
    }
}